const styleNoTag = {
    color: '#525252',
    backgroundColor: '#ffffff00',
    border: 'solid #ffffff00 1px !important'
};

const styleTagDefault = {
    color: '#525252',
    backgroundColor: '#F5F5F5',
    borderRadius: '3px !important',
    border: 'solid #E0E0E0 1px !important'
};

const styleTagSuccess = {
    color: '#1F5B21',
    backgroundColor: '#EBF4EB',
    borderRadius: '3px !important',
    border: 'solid #C0DDC1 1px !important'
};

const styleTagError = {
    color: '#991F1A',
    backgroundColor: '#FCEBEA',
    borderRadius: '3px !important',
    border: 'solid #F4C1BE 1px !important'
};

const styleTagWarning = {
    color: '#6D4D09',
    backgroundColor: '#FDF7E8',
    borderRadius: '3px !important',
    border: 'solid #F9E5B9 1px !important'
};

const styleTagCustomBlue = {
    color: '#0A4D94',
    backgroundColor: '#ECF5FF',
    borderRadius: '3px !important',
    border: 'solid #D9ECFF 1px !important'
};

const styleTagCustomPurple = {
    color: '#8C1283',
    backgroundColor: '#FFF3FF',
    borderRadius: '3px !important',
    border: 'solid #FFCEFE 1px !important'
};

const styleTagCustomBlueWhiteColors = {
    color: '#0A4D94',
    backgroundColor: '#FFFFFF',
    borderRadius: '3px !important',
    border: 'solid #D9ECFF 1px !important'
};

const styleTagSuccessWhiteColors = {
    color: '#1F5B21',
    backgroundColor: '#FFFFFF',
    borderRadius: '3px !important',
    border: 'solid #C0DDC1 1px !important'
};

const enumsNoColors = ['SEM_STATUS'];
const enumsDefaultColors = ['NA_FILA', 'NAO_ANALISADO', 'GERANDO_TRILHA', 'EM_PROCESSAMENTO'];
const enumsSuccessColors = ['ATIVO', 'ANALISADO', 'CONFORME', 'VISUALIZADO', 'SEM_PENDENCIA'];
const enumsErrorColors = ['SUSPENSO', 'CANCELADO', 'INCONFORME', 'ERRO_CONTATO', 'ERRO_ENVIO', 'ERRO_GERACAO_TRILHA', 'ERRO_PROCESSAMENTO'];
const enumsWarningtColors = ['PENDENTE', 'EM_ANALISE', 'AGUARDANDO_ANALISE', 'POSSIVEL_INCONSISTENCIA', 'COM_PENDENCIA'];
const enumsCustomBlueColors = ['ENVIADO'];
const enumsCustomPurpleColors = ['NA_FILA_ENVIO'];
const enumsCustomBlueWhiteColors = ['AGUARDANDO_ENVIO'];
const enumsSuccessWhiteColors = ['SEM_TRILHA'];

export function identificarStyleTag(tipoEnum) {
    if (enumsNoColors.includes(tipoEnum)) return styleNoTag;
    if (enumsDefaultColors.includes(tipoEnum)) return styleTagDefault;
    if (enumsSuccessColors.includes(tipoEnum)) return styleTagSuccess;
    if (enumsErrorColors.includes(tipoEnum)) return styleTagError;
    if (enumsWarningtColors.includes(tipoEnum)) return styleTagWarning;
    if (enumsCustomBlueColors.includes(tipoEnum)) return styleTagCustomBlue;
    if (enumsCustomPurpleColors.includes(tipoEnum)) return styleTagCustomPurple;
    if (enumsCustomBlueWhiteColors.includes(tipoEnum)) return styleTagCustomBlueWhiteColors;
    if (enumsSuccessWhiteColors.includes(tipoEnum)) return styleTagSuccessWhiteColors;

    return '';
}
